import MovieList from './movie-list';

export default MovieList;
